import * as PopoverPrimitive from '@radix-ui/react-popover'
import * as React from 'react'
import { cn } from '#app/utils/misc'

const Popover = PopoverPrimitive.Root
const PopoverTrigger = PopoverPrimitive.Trigger
const PopoverAnchor = PopoverPrimitive.Anchor

const PopoverContent = React.forwardRef<
	React.ElementRef<typeof PopoverPrimitive.Content>,
	React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content> & {
		disablePortal?: boolean
	}
>(
	(
		{
			className,
			align = 'center',
			sideOffset = 4,
			disablePortal = false,
			...props
		},
		ref,
	) => {
		const content = (
			<PopoverPrimitive.Content
				ref={ref}
				align={align}
				sideOffset={sideOffset}
				className={cn(
					'z-50 w-72 rounded-md border bg-white p-4 text-popover-foreground shadow-md outline-none',
					className,
				)}
				{...props}
			/>
		)

		return disablePortal ? (
			content
		) : (
			<PopoverPrimitive.Portal>{content}</PopoverPrimitive.Portal>
		)
	},
)
PopoverContent.displayName = PopoverPrimitive.Content.displayName

export { Popover, PopoverTrigger, PopoverAnchor, PopoverContent }
